/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_9760eb9a","_9760eb9a",""]'><div :class='["","_9760eb9a",""]'><cube-button @_click="showPicker" :class='["","_9760eb9a",""]'>async-cascade-picker</cube-button><cube-cascade-picker-popup ref="__mpx_ref_asyncPicker__" :title="('标题')" :list="(dataList)" :selectedIndex="(selectedIndex)" :async="(true)" @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' :class='["","_9760eb9a",""]'/><div :class='["event-params","m-t-10","_9760eb9a",""]' v-if="(changeParams || introduce)"><div :class='["key-introduce","_9760eb9a",""]'>{{introduce}}</div><div :class='["desc-text","m-t-10","m-b-10","_9760eb9a",""]'>因设置 async 为true，change 事件会在用户更新数据后才相应；例子里第二例滚动时没有更新数据，所以无 change 事件。</div><template v-if="(changeParams)"><div :class='["m-b-10","_9760eb9a",""]'>change 事件参数：</div><div :class='["value","m-b-10","_9760eb9a",""]'><div view v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_9760eb9a",""]'><div :class='["item-key","_9760eb9a",""]'>{{item[0]}}</div><div :class='["item-value","_9760eb9a",""]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_9760eb9a"}'>
.event-params
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px
.desc-text
  font-size: 14px
  color: #4b4b4b
  line-height: 1.3
.m-t-10
  margin-top: 10px
.m-b-10
  margin-bottom: 10px
.key-introduce
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_9760eb9a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_9760eb9a"}
  /** script content **/
  require("./async-picker.mpx.js?isComponent&outputPath=components%2Fasync-picker9760eb9a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./async-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fasync-picker9760eb9a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_9760eb9a"],
    ctorType: "component",
    outputPath: "components/async-picker9760eb9a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-cascade-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/cascade-picker-popup/index.mpx?isComponent&outputPath=components%2Findex2c8c38ed%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>